module.exports = __webpack_public_path__ + "img/layouts.98339f2b.svg";